import Dashboard from "../Pages/Dashboard";
import CreateUser from "../Pages/Users/CreateUser";
import UpdateUser from "../Pages/Users/UpdateUser";
import Users from "../Pages/Users";
import Groups from "../Pages/Groups";
import CreateGroup from "../Pages/Groups/CreateGroup";
import UpdateGroup from "../Pages/Groups/UpdateGroup";
import SeasonalRecruitment from "../Pages/SeasonalRecruitment";
import MadinaDashboard from "../Pages/MadinaDashboard/MadinaDashboard.jsx";
import DisplayUserProfile from "../Pages/Users/DisplayUserProfile";
import { ResetUserPassword } from "../Pages/ResetUserPassword/ResetUserPassword.jsx";
import { BasicDataTabs } from "../Pages/BasicData/BasicDataTabs.jsx";
import { CreateBank } from "../Pages/BasicData/CreateBank.jsx";
import { EditBank } from "../Pages/BasicData/EditBank.jsx";
import { CreateQualification } from "../Pages/BasicData/CreateQualification.jsx";
import { EditQualification } from "../Pages/BasicData/EditQualification.jsx";
import { CreateDepartment } from "../Pages/BasicData/CreateDepartment.jsx";
import { EditDepartment } from "../Pages/BasicData/EditDepartment.jsx";
import { CreateJob } from "../Pages/BasicData/CreateJob.jsx";
import { EditJob } from "../Pages/BasicData/EditJob.jsx";
import { CreateCity } from "../Pages/BasicData/CreateCity.jsx";
import { EditCity } from "../Pages/BasicData/EditCity.jsx";
import { CreateInitialGroup } from "../Pages/BasicData/InitialGroup/CreateInitialGroup.jsx";
import UpdateInitialGroup from "../Pages/BasicData/InitialGroup/UpdateInitialGroup.jsx";
import { CreateInitialCampaign } from "../Pages/BasicData/InitialCampaign/CreateInitialCampaign.jsx";
import UpdateInitialCampaign from "../Pages/BasicData/InitialCampaign/UpdateInitialCampaign.jsx";
import { CreatePort } from "../Pages/BasicData/CreatePort.jsx";
import { EditPort } from "../Pages/BasicData/EditPort.jsx";
import { CreateDirection } from "../Pages/BasicData/CreateDirection.jsx";
import { EditDirection } from "../Pages/BasicData/EditDirection.jsx";
import { CreateServiceCenter } from "../Pages/BasicData/CreateServiceCenter.jsx";
import { EditServiceCenter } from "../Pages/BasicData/EditServiceCenter.jsx";
import { CreateTransportation } from "../Pages/BasicData/CreateTransportation.jsx";
import { EditTransportation } from "../Pages/BasicData/EditTransportation.jsx";
import { CreateAirline } from "../Pages/BasicData/CreateAirline.jsx";
import { EditAirline } from "../Pages/BasicData/EditAirline.jsx";
import { CreateState } from "../Pages/BasicData/CreateState.jsx";
import { EditState } from "../Pages/BasicData/EditState.jsx";
import { MakkahCampain } from "../Component/MakkahCampain/MakkahCampain.jsx";
import { UpdateCampaign } from "../Pages/Campaigns";
import UpdateMakkahGroup from "../Pages/Makkah/Groups/UpdateGroup";
import { NotFound } from "../Pages/NotFound";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import { PilgrimDetails } from "../Pages/Makkah/PilgrimsAndGroups/PilgrimsDetails";
// Makkah Platform Imports
import {
  OrganizersAndContracts,
  Visas,
  Housing,
  MakkahGroups,
  Camps,
  Compliance,
} from "../Pages/Makkah/PlanningAndPreparation";
import { CenterReceptionJeddah, CenterReceptionMadina } from "../Pages/Makkah/Reception";
import {
  HousingPermits,
  HousingContracts,
  InspectionItems,
  HousingInspection,
  HousingInspectionOrder,
  BuildingsNotInspected,
} from "../Pages/Makkah/HousingAndAccommodations";
import {
  Pilgrims,
  CampaignAccommodation,
  GroupSettlement,
  GroupPilgrimsQuery,
} from "../Pages/Makkah/PilgrimsAndGroups";
import {
  NusukCardsNewBatches,
  NusukCardsBatchReturns,
  EditNusukCardsReturn,
  NusukCardsReturnDetails,
  EditNusukCardsBatch,
  NusukCardsBatchDetails,
  EnterNewReceivedBatchesData,
  NusukCardsInquiry,
  NusukCardsReports,
} from "../Pages/Makkah/NusukCards";
import CampaignSettlementPage from "../Pages/Makkah/PilgrimsAndGroups/CampaignSettlementPage";
import { Incidents, Reports, CreateReport, ViewReport } from "../Pages/Makkah/ReportsAndIncidents";
import { InitialDeparturePilgrims, Flights, CreateFlight, PrivateTransportContracts } from "../Pages/Makkah/Departure";
import {
  CampaignAndGroupReports,
  ReceptionAndArrivalReports,
  DepartureReports,
  HousingReports,
  PilgrimReports as MakkahPilgrimReports,
  IncidentAndReportLogs,
  ComplianceReports,
  UsersAndServiceCenters,
} from "../Pages/Makkah/ReportsAndStatistics";
import { HousingContractDetailReport } from "@/Pages/Makkah/Reports/HousingContractDetailReport";
import { HouseContractCampaignsReport } from "@/Pages/Makkah/Reports/HouseContractCampaignsReport";
import { FoodContractsReport } from "@/Pages/Makkah/Reports/FoodContractsReport";
import { HousingComprehensiveDetailReport } from "@/Pages/Makkah/Reports/HousingComprehensiveDetailReport";
import { HousingBuildingDelegateDetailReport } from "@/Pages/Makkah/Reports/HousingBuildingDelegateDetailReport";
import { PilgrimNationalityStatsReport } from "@/Pages/Makkah/Reports/PilgrimNationalityStatsReport";
import { PilgrimMissionStatsReport } from "@/Pages/Makkah/Reports/PilgrimMissionStatsReport";
import { AccommodatedPilgrimNationalityStatsReport } from "@/Pages/Makkah/Reports/AccommodatedPilgrimNationalityStatsReport";
import { AccommodatedPilgrimMissionStatsReport } from "@/Pages/Makkah/Reports/AccommodatedPilgrimMissionStatsReport";
import { HousingContractDetailReport as MadinahHousingContractDetailReport } from "@/Pages/Madinah/Reports/HousingContractDetailReport";
import { HouseContractCampaignsReport as MadinahHouseContractCampaignsReport } from "@/Pages/Madinah/Reports/HouseContractCampaignsReport";
import { FoodContractsReport as MadinahFoodContractsReport } from "@/Pages/Madinah/Reports/FoodContractsReport";
import { HousingComprehensiveDetailReport as MadinahHousingComprehensiveDetailReport } from "@/Pages/Madinah/Reports/HousingComprehensiveDetailReport";
import { HousingBuildingDelegateDetailReport as MadinahHousingBuildingDelegateDetailReport } from "@/Pages/Madinah/Reports/HousingBuildingDelegateDetailReport";
import { ServiceCenters, SystemSecurity } from "../Pages/Makkah/SystemManagement";
import { Archives } from "../Pages/Makkah/Archives";

// Madina Platform Imports
import {
  OrganizersAndContracts as MadinaOrganizersAndContracts,
  Visas as MadinaVisas,
  Housing as MadinaHousing,
  Compliance as MadinaCompliance,
} from "../Pages/Madinah/PlanningAndPreparation";
import {
  HousingInspectionMonitoring as MadinaHousingInspectionMonitoring,
  FollowUpReadinessReports as MadinaFollowUpReadinessReports,
  BuildingsNotInspected as MadinaBuildingsNotInspected,
} from "../Pages/Madinah/HousingAndAccommodations";
import { PilgrimsAndGroupsManagement, GroupPilgrimsQueries } from "../Pages/Madinah/PilgrimsAndGroups";
import { Incidents as MadinaIncidents } from "../Pages/Madinah/ReportsAndIncidents";
import {
  PilgrimReports as MadinaPilgrimReports,
  CampaignAndGroupReports as MadinaCampaignAndGroupReports,
  ReceptionAndArrivalReports as MadinaReceptionAndArrivalReports,
  DepartureReports as MadinaDepartureReports,
  HousingReports as MadinaHousingReports,
  IncidentAndReportLogs as MadinaIncidentAndReportLogs,
  ComplianceReports as MadinaComplianceReports,
  UsersAndServiceCenters as MadinaUsersAndServiceCenters,
} from "../Pages/Madinah/ReportsAndStatistics";
import { CampaignGroupPilgrimsReport } from "@/Pages/Madinah/Reports/CampaignGroupPilgrimsReport";
import { useEffect } from "react";
import { HousingDetails } from "../Pages/Makkah/HousingAndAccommodations/HousingDetails.jsx";
import { UpdateHousingContract } from "../Pages/Makkah/HousingAndAccommodations/UpdateHousingContract.jsx";
import { ViewHousingContract } from "../Pages/Makkah/HousingAndAccommodations/ViewHousingContract.jsx";
import { CreateHousingInspection } from "@/Pages/Makkah/HousingAndAccommodations/CreateHousingInspection";
import { EditHousingInspection } from "@/Pages/Makkah/HousingAndAccommodations/EditHousingInspection";
import { HousingInspectionExamination } from "@/Pages/Makkah/HousingAndAccommodations/HousingInspectionExamination";
import { HousingInspectionOrderHouses } from "@/Pages/Makkah/HousingAndAccommodations/HousingInspectionOrderHouses";
import HousingInspectionNotes from "@/Pages/HousingInspectionNotes";
import { HouseExaminationItemPage } from "@/Pages/BasicData/CreateHouseExaminationItem";
import { ExaminationPeriodPage } from "@/Pages/BasicData/CreateExaminationPeriod";
import { PeriodCodePage } from "@/Pages/BasicData/CreatePeriodCode";
import ReceptionJeddah from "@/Pages/Makkah/Reception/ReceptionJeddah";
import { ReceptionMadina } from "@/Pages/Madinah/Reception";
import { MakkahBags } from "@/Pages/Madinah/Reception/Bags";
import { MODES, ROLES, permissions } from "@/utils/constants";
import { DepartureCampaign } from "@/Pages/UpComming/DepartureCampaign";
import { CampaignAndGroupDeparture } from "@/Pages/CampaignAndGroupDeparture/CampaignAndGroupDeparture";
import { MakkahPilgrimGroupNameMappingFrom } from "@/Pages/BasicData/MakkahPilgrimGroupNameMappingFrom";
import { JobSectorsForm } from "@/Pages/BasicData/Forms/JobSectorsForm";
import { ConfirmDepartureList } from "@/Pages/Departure/ConfirmDepartureList";
import { NotComingPilgrimsReport } from "@/Pages/Madinah/Reports/NotComingPilgrimsReport";
import { NotAccommodatedPilgrimsReport } from "@/Pages/Madinah/Reports/NotAccommodatedPilgrimsReport";
import { DepartureGroupDetail } from "@/Pages/Makkah/PlanningAndPreparation/DepartureGroupDetail";
import PermissionGate from "@/CommonElements/PermissionGate";
import { useSystem } from "@/utils/hooks/useLocation";
import { NoAccess } from "@/CommonElements/NoAccess";
import usePermissions from "@/utils/hooks/usePermissions";
import CampaignsAndGroupsReports from "@/Pages/Makkah/ReportsAndStatistics/CampaignsAndGroupsReports";
import PilgrimMissionArrivingLeavingStatisticsReport from "@/Pages/Makkah/ReportsAndStatistics/CampaignsAndGroupsReports/PilgrimMissionArrivingLeavingStatisticsReport";
import UpcomingGroupsAndCampaignsDetailsReport from "@/Pages/Makkah/ReportsAndStatistics/CampaignsAndGroupsReports/UpcomingGroupsAndCampaignsDetailsReport";
import ActivityLogs from "@/Component/shared/ActivityLogs";

// `groups-departure/:id/:port/:mode` – permissions are for the **Departure** flow, not `UpcommingGroups`.
// Replace PermissionGate `permission` values with departure-specific full names when product provides them.
const DepartureGroupDetailMode = () => {
  const { mode } = useParams();
  const { currentSystem } = useSystem();
  const isMadina = currentSystem === "madina";
  if (mode === "view") {
    return (
      <PermissionGate
        permissions={[
          isMadina
            ? permissions.view_groups_for_madina
            : permissions.view_groups
        ]}
      >
        <DepartureGroupDetail />
      </PermissionGate>
    );
  }
  if (mode === "edit") {
    return (
      <PermissionGate
        permissions={[
          isMadina
            ? permissions.update_group_details_for_madina
            : permissions.update_group_details
        ]}
      >
        <DepartureGroupDetail />
      </PermissionGate>
    );
  }
  return <NotFound />;
};

const ArrivalCampaignByIdMode = () => {
  const { mode } = useParams();
  return mode === "edit" || mode === "view" ? <UpdateCampaign /> : <NotFound />;
};

const HouseExaminationItemCRUDMode = () => {
  const { mode } = useParams();
  const modes = ["create", "edit", "view"];
  return modes.includes(mode) ? <HouseExaminationItemPage /> : <NotFound />;
};

const ExaminationPeriodCRUDMode = () => {
  const { mode } = useParams();
  const modes = ["create", "edit", "view"];
  return modes.includes(mode) ? <ExaminationPeriodPage /> : <NotFound />;
};

const PeriodCodeCRUDMode = () => {
  const { mode } = useParams();
  const modes = ["create", "edit", "view"];
  return modes.includes(mode) ? <PeriodCodePage /> : <NotFound />;
};

const InitialGroupMode = () => {
  const { mode } = useParams();
  const { currentSystem } = useSystem();
  const isMadina = currentSystem === "madina";
  if (mode === "view") {
    return (
      <PermissionGate
        permissions={[
          isMadina
            ? permissions.view_groups_for_madina
            : permissions.view_groups
        ]}
      >
        <UpdateInitialGroup />
      </PermissionGate>
    );
  }
  if (mode === "edit") {
    return (
      <PermissionGate
        permissions={[
          isMadina
            ? permissions.update_groups_for_madina
            : permissions.update_groups
        ]}
      >
        <UpdateInitialGroup />
      </PermissionGate>
    );
  }
  return <NotFound />;
};

const InitialCampaignMode = () => {
  const { mode } = useParams();
  const { from_id } = useSystem();

  if (mode === "view")
    return (
      <PermissionGate permissions={[from_id === 1 ? permissions.view_campaign_details : permissions.view_campaign_details_for_madina]}>
        <UpdateInitialCampaign />
      </PermissionGate>
    );

  if (mode === "edit")
    return (
      <PermissionGate permissions={[from_id === 1 ? permissions.update_campaigns : permissions.update_campaigns_for_madina]}>
        <UpdateInitialCampaign />
      </PermissionGate>
    );

  return <NotFound />;
};

const ReceptionMode = () => {
  const { port } = useParams();
  const RoutesComponents = {
    JED: <ReceptionJeddah />,
  };

  return RoutesComponents?.[port] || <NotFound />;
};

const ReceptionMadinaMode = () => {
  const { id, mode } = useParams();

  if (!Object.values(MODES).includes(mode)) return <NotFound />;

  let inner = <ReceptionMadina />;

  if (mode === MODES.create) {
    inner = (
      <PermissionGate permissions={[permissions.create_arrival_reports_for_madina]}>
        {inner}
      </PermissionGate>
    );
  } else if (id && mode === MODES.edit) {
    inner = (
      <PermissionGate permissions={[permissions.update_arrival_reports_for_madina]}>
        {inner}
      </PermissionGate>
    );
  }

  return (
    <PermissionGate permissions={[permissions.list_port_reception_cards_from_nusk_for_madina]}>
      {inner}
    </PermissionGate>
  );
};

const MadinaBagsRoute = () => {
  const { mode } = useParams();
  const isEdit = mode === MODES.edit;
  return (
    <PermissionGate permissions={[permissions.list_arrival_bags_for_madina]}>
      {isEdit ? (
        <PermissionGate permissions={[permissions.update_arrival_bags_for_madina]}>
          <MakkahBags />
        </PermissionGate>
      ) : (
        <MakkahBags />
      )}
    </PermissionGate>
  );
};

const CenterReceptionMode = () => {
  const { port } = useParams();

  const RoutesComponents = {
    JED: (
      <PermissionGate
        permissions={[
          permissions.list_center_reception_cards_from_ports,
          permissions.list_center_reception_cards_between_cities,
        ]}
      >
        <CenterReceptionJeddah />
      </PermissionGate>
    ),
    MED: (
      <PermissionGate
        mode="any"
        permissions={[
          permissions.list_makkah_reception_manifests,
          permissions.list_makkah_reception_manifest_pilgrims,
          permissions.list_makkah_reception_tafweejs,
          permissions.list_makkah_reception_tafweej_pilgrims,
        ]}
      >
        <CenterReceptionMadina />
      </PermissionGate>
    ),
  };

  return RoutesComponents?.[port] || <NotFound />;
};
const GroupMode = () => {
  const { mode } = useParams();
  const { currentSystem } = useSystem();
  const isMadina = currentSystem === "madina";
  if (mode === "view") {
    return (
      <PermissionGate
        permissions={[
          isMadina
            ? permissions.view_groups_for_madina
            : permissions.view_groups
        ]}
      >
        <UpdateMakkahGroup />
      </PermissionGate>
    );
  }
  if (mode === "edit") {
    return (
      <PermissionGate
        permissions={[
          isMadina
            ? permissions.view_groups_for_madina
            : permissions.view_groups
        ]}
      >
        <UpdateMakkahGroup />
      </PermissionGate>
    );
  }
  return <NotFound />;
};

const makkahBasicDataKeys = [
  "cities",
  "ports",
  "directions",
  "service-centers",
  "transportations",
  "airlines",
  "states",
  "house_examination_items",
  "examination_periods",
  "period_codes",
  "makkah-pilgrim-group-name-mappings",
];

const BasicData = () => {
  const { key } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    hasAnyPermission
  } = usePermissions();
  const isSeasonalHr = location.pathname.includes("seasonal_hr");
  const isMadina = location.pathname.includes("madina");
  const basePath = isSeasonalHr
    ? "/app/seasonal_hr/basic-data"
    : isMadina
      ? "/app/madina/basic-data"
      : "/app/makkah/basic-data";
  const keys = isSeasonalHr ? ["qualifications", "banks", "job-sectors", "departments", "jobs"] : makkahBasicDataKeys;
  const defaultKey = isSeasonalHr ? "qualifications" : isMadina ? "cities" : "makkah-pilgrim-group-name-mappings";

  // Redirect from base path to default tab
  useEffect(() => {
    if (!key) {
      navigate(`${basePath}/${defaultKey}`, { replace: true });
    }
  }, [key, basePath, defaultKey, navigate]);

  if (!hasAnyPermission([ROLES.super_admin])) {
    return <NoAccess />;
  }

  if (!keys.includes(key)) {
    return <></>;
  }

  return <BasicDataTabs />;
};

const HousingInspectionOrderFormMode = () => {
  const { mode } = useParams();

  if (mode === "create") return <CreateHousingInspection />;
  return mode === "edit" || mode === "view" ? <EditHousingInspection /> : <NotFound />;
};

const makkahRoutes = [
  {
    path: "makkah",
    Component: <Dashboard />,
  },
  {
    path: "makkah/arrival-campaign",
    Component: (
      <PermissionGate mode="any" permissions={[
        permissions.list_campaigns,
        permissions.view_campaigns,
        permissions.create_campaigns,
        permissions.update_campaigns,
        permissions.delete_campaigns,
        permissions.list_campaign_details,
        permissions.view_campaign_details,
        permissions.create_campaign_details,
        permissions.update_campaign_details,
        permissions.delete_campaign_details,
      ]}>
        <MakkahCampain />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/departure-campaign",
    Component: (
      <PermissionGate
        mode="any"
        permissions={[
          permissions.list_departure_campaigns,
          permissions.view_departure_campaigns,
          permissions.create_departure_campaigns,
          permissions.update_departure_campaigns,
          permissions.delete_departure_campaigns,
          permissions.list_departure_campaign_details,
          permissions.view_departure_campaign_details,
          permissions.create_departure_campaign_details,
          permissions.update_departure_campaign_details,
          permissions.delete_departure_campaign_details,
        ]}
      >
        <MakkahCampain />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/departure-campaign/:id/:port/:mode",
    Component: (
      <PermissionGate
        mode="any"
        permissions={[permissions.view_departure_campaigns]}
      >
        <DepartureCampaign />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/campaigns",
    Component: <MakkahCampain />,
  },
  {
    path: "makkah/arrival-campaign/:id/:port/:mode",
    Component: (
      <PermissionGate permissions={[permissions.view_campaigns]}>
        <ArrivalCampaignByIdMode />
      </PermissionGate>
    ),
  },
  // Basic Data Routes - Redirect base path to cities
  {
    path: "makkah/basic-data/makkah-pilgrim-group-name-mappings/:action",
    Component: <MakkahPilgrimGroupNameMappingFrom />,
  },
  {
    path: "makkah/basic-data/makkah-pilgrim-group-name-mappings/:id/:action",
    Component: <MakkahPilgrimGroupNameMappingFrom />,
  },
  {
    path: "makkah/basic-data",
    Component: <BasicData />,
  },
  {
    path: "makkah/basic-data/:key",
    Component: <BasicData />,
  },
  {
    path: "makkah/basic-data/cities/create",
    Component: <CreateCity />,
  },
  {
    path: "makkah/basic-data/cities/:id/edit",
    Component: <EditCity />,
  },
  {
    path: "makkah/basic-data/:key",
    Component: <BasicData />,
  },
  {
    path: "makkah/basic-data/banks/create",
    Component: <CreateBank />,
  },
  {
    path: "makkah/basic-data/banks/:id/edit",
    Component: <EditBank />,
  },
  {
    path: "makkah/basic-data/:key",
    Component: <BasicData />,
  },
  {
    path: "makkah/basic-data/:key",
    Component: <BasicData />,
  },
  {
    path: "makkah/basic-data/job-sectors/create",
    Component: <JobSectorsForm />,
  },
  {
    path: "makkah/basic-data/job-sectors/:id/:action",
    Component: <JobSectorsForm />,
  },
  {
    path: "makkah/basic-data/groups/create",
    Component: (
      <PermissionGate permissions={[permissions.create_groups]}>
        <CreateInitialGroup />
      </PermissionGate>
    ),
  },
  {
    path: "madina/basic-data/groups/create",
    Component: (
      <PermissionGate permissions={[permissions.create_groups_for_madina]}>
        <CreateInitialGroup />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/basic-data/:key",
    Component: <BasicData />,
  },
  {
    path: "makkah/basic-data/house_examination_items/:mode",
    Component: <HouseExaminationItemCRUDMode />,
  },
  {
    path: "makkah/basic-data/house_examination_items/:id/:mode",
    Component: <HouseExaminationItemCRUDMode />,
  },
  {
    path: "makkah/basic-data/examination_periods/:mode",
    Component: <ExaminationPeriodCRUDMode />,
  },
  {
    path: "makkah/basic-data/examination_periods/:id/:mode",
    Component: <ExaminationPeriodCRUDMode />,
  },
  {
    path: "makkah/basic-data/period_codes/:mode",
    Component: <PeriodCodeCRUDMode />,
  },
  {
    path: "makkah/basic-data/period_codes/:id/:mode",
    Component: <PeriodCodeCRUDMode />,
  },
  {
    path: "makkah/basic-data/groups-upcoming",
    Component: <Navigate to="/app/makkah/groups-upcoming" />,
  },
  {
    path: "makkah/basic-data/groups-upcoming/:id/:mode",
    Component: <InitialGroupMode />,
  },
  {
    path: "makkah/basic-data/campaigns/create",
    Component: <CreateInitialCampaign />,
  },
  {
    path: "makkah/basic-data/campaigns/:id/:mode",
    Component: <InitialCampaignMode />,
  },
  {
    path: "makkah/basic-data/ports/create",
    Component: <CreatePort />,
  },
  {
    path: "makkah/basic-data/ports/:id/edit",
    Component: <EditPort />,
  },
  {
    path: "makkah/basic-data/directions/create",
    Component: <CreateDirection />,
  },
  {
    path: "makkah/basic-data/directions/:id/edit",
    Component: <EditDirection />,
  },
  {
    path: "makkah/basic-data/service-centers/create",
    Component: <CreateServiceCenter />,
  },
  {
    path: "makkah/basic-data/service-centers/:id/edit",
    Component: <EditServiceCenter />,
  },
  {
    path: "makkah/basic-data/transportations/create",
    Component: <CreateTransportation />,
  },
  {
    path: "makkah/basic-data/transportations/:id/edit",
    Component: <EditTransportation />,
  },
  {
    path: "makkah/basic-data/airlines/create",
    Component: <CreateAirline />,
  },
  {
    path: "makkah/basic-data/airlines/:id/edit",
    Component: <EditAirline />,
  },
  {
    path: "makkah/basic-data/states/create",
    Component: <CreateState />,
  },
  {
    path: "makkah/basic-data/states/:id/edit",
    Component: <EditState />,
  },
  // Planning and Preparation Routes
  {
    path: "makkah/organizers-and-contracts",
    Component: (
      <PermissionGate permissions={[permissions.view_organizers]}>
        <OrganizersAndContracts />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/visas",
    Component: (
      <PermissionGate permissions={[permissions.view_visas]}>
        <Visas />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/housing",
    Component: <Housing />,
  },
  {
    path: "makkah/groups-upcoming",
    Component: (
      <PermissionGate permissions={[permissions.list_groups]}>
        <MakkahGroups />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/groups-departure",
    Component: (
      <PermissionGate permissions={[permissions.list_groups]}>
        <MakkahGroups />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/groups-departure/:id/:port/:mode",
    Component: <DepartureGroupDetailMode />,
  },
  {
    path: "makkah/groups-upcoming/:mode",
    Component: <GroupMode />,
  },
  {
    path: "makkah/groups-upcoming/:id/:mode",
    Component: <GroupMode />,
  },
  {
    path: "makkah/camps",
    Component: <Camps />,
  },
  {
    path: "makkah/compliance",
    Component: <Compliance />,
  },
  // Reception Routes
  {
    path: "makkah/:port/reception",
    Component: (
      <PermissionGate
        permissions={[
          permissions.list_port_reception_cards_from_missions,
          permissions.list_port_reception_cards_from_nask,
        ]}
        mode="any"
      >
        <ReceptionMode />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/bags",
    Component: <MadinaBagsRoute />,
  },
  {
    path: "makkah/bags/:bag_id/request/:request_number/:mode",
    Component: <MadinaBagsRoute />,
  },
  // Center Reception Routes
  {
    path: "makkah/:port/center-reception",
    Component: <CenterReceptionMode />,
  },
  // المساكن
  {
    path: "makkah/housing-permits",
    Component: (
      <PermissionGate permissions={[permissions.list_housing]}>
        <HousingPermits />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/housing-permits/:id",
    Component: (
      <PermissionGate permissions={[permissions.view_housing_details]}>
        <HousingDetails />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/housing-permits/:id/edit",
    Component: (
      <PermissionGate permissions={[permissions.edit_housing_data]}>
        <UpdateHousingContract />
      </PermissionGate>
    ),
  },
  // عقود السكن
  {
    path: "makkah/housing-contracts",
    Component: (
      <PermissionGate permissions={[permissions.list_housing_contracts]}>
        <HousingContracts />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/housing-contracts/:id/view",
    Component: (
      <PermissionGate permissions={[permissions.view_housing_contract_details]}>
        <ViewHousingContract />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/inspection-items",
    Component: <InspectionItems />,
  },
  // فحص جاهزية السكن
  {
    path: "makkah/housing-inspection",
    Component: (
      <PermissionGate permissions={[permissions.list_house_inspection_examinations]}>
        <HousingInspection />
      </PermissionGate>
    ),
  },
  // اوامر فحص السكن
  {
    path: "makkah/housing-Inspection-orders",
    Component: (
      <PermissionGate permissions={[permissions.list_house_inspection_orders]}>
        <HousingInspectionOrder />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/housing-Inspection-orders/:order_number/buildings",
    Component: <HousingInspectionOrderHouses />,
  },
  {
    path: "makkah/housing-Inspection-orders/:mode",
    Component: <HousingInspectionOrderFormMode />,
  },
  {
    path: "makkah/housing-Inspection-orders/:order_number/:mode",
    Component: <HousingInspectionOrderFormMode />,
  },
  {
    path: "makkah/housing-Inspection-orders/:order_number/buildings/:house_id/housing-inspection-items",
    Component: <HousingInspectionExamination />,
  },
  // ملاحظات فحص السكن
  {
    path: "makkah/housing-inspection-notes",
    Component: (
      <PermissionGate permissions={[permissions.view_house_inspection_results]}>
        <HousingInspectionNotes />
      </PermissionGate>
    ),
  },
  // بلاغات جاهزية السكن
  {
    path: "makkah/buildings-not-inspected",
    Component: (
      <PermissionGate permissions={[permissions.list_house_inspection_examination_periods]}>
        <BuildingsNotInspected />
      </PermissionGate>
    ),
  },
  // Pilgrims and Groups Routes
  {
    path: "makkah/pilgrims",
    Component: <Pilgrims />,
  },
  {
    path: "makkah/pilgrims/:id/view",
    Component: <PilgrimDetails />,
  },
  {
    path: "makkah/campaign-settlement",
    Component: (
      <PermissionGate permissions={[permissions.view_accommodations]}>
        <CampaignAccommodation />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/campaign-settlement/:type/:id/pilgrims",
    Component: (
      <PermissionGate permissions={[permissions.view_accommodations]}>
        <CampaignSettlementPage />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/group-settlement",
    Component: <GroupSettlement />,
  },
  {
    path: "makkah/group-pilgrims-query",
    Component: (
      <PermissionGate permissions={[permissions.list_makkah_group_pilgrims_inquiry]}>
        <GroupPilgrimsQuery />
      </PermissionGate>
    ),
  },
  // Nusuk Cards Routes
  {
    path: "makkah/nusuk-cards",
    Component: <PermissionGate permissions={[permissions.list_nusuk_cards_batchs]}>
      <NusukCardsNewBatches />
    </PermissionGate>,
  },
  {
    path: "makkah/nusuk-cards/returns",
    Component: <PermissionGate permissions={[permissions.list_nusuk_cards_batch_returns]}>
      <NusukCardsBatchReturns />
    </PermissionGate>,
  },
  {
    path: "makkah/nusuk-cards/returns/:returnId/view",
    Component: <PermissionGate permissions={[permissions.list_nusuk_cards_batch_returns]}>
      <NusukCardsReturnDetails />
    </PermissionGate>,
  },
  {
    path: "makkah/nusuk-cards/returns/:returnId/edit",
    Component: <PermissionGate permissions={[permissions.update_nusuk_cards_batch_returns]}>
      <EditNusukCardsReturn />
    </PermissionGate>,
  },
  {
    path: "makkah/nusuk-cards/enter-new-received-new-batches-data",
    Component: <PermissionGate permissions={[permissions.create_nusuk_cards_batchs]}>
      <EnterNewReceivedBatchesData />
    </PermissionGate>,
  },
  {
    path: "makkah/nusuk-cards/:id/edit",
    Component: <PermissionGate permissions={[permissions.update_nusuk_cards_batchs]}>
      <EditNusukCardsBatch />
    </PermissionGate>,
  },
  {
    path: "makkah/nusuk-cards/:id/view",
    Component: <PermissionGate permissions={[permissions.view_nusuk_cards_batchs]}>
      <NusukCardsBatchDetails />
    </PermissionGate>,
  },
  {
    path: "makkah/nusuk-cards-inquiry",
    Component: <PermissionGate permissions={[permissions.list_nusuk_cards_batchs]}>
      <NusukCardsInquiry />
    </PermissionGate>,
  },
  {
    path: "makkah/nusuk-cards-reports",
    Component: <PermissionGate permissions={[permissions.view_export_nusuk_cards_batch_report]}>
      <NusukCardsReports />
    </PermissionGate>,
  },

  // Reports and Incidents Routes
  {
    path: "makkah/incidents",
    Component: <Incidents />,
  },
  {
    path: "makkah/reports/create",
    Component: (
      <PermissionGate permissions={[permissions.create_makkah_incident_reports]}>
        <CreateReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/reports/:id/view",
    Component: (
      <PermissionGate permissions={[permissions.view_makkah_incident_reports_details]}>
        <ViewReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/reports/:id/edit",
    Component: (
      <PermissionGate permissions={[permissions.update_makkah_incident_reports]}>
        <CreateReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/reports",
    Component: (
      <PermissionGate permissions={[permissions.list_makkah_incident_reports]}>
        <Reports />
      </PermissionGate>
    ),
  },
  // Departure Routes
  {
    path: "makkah/initial-departure-pilgrims",
    Component: (
      <PermissionGate
        permissions={[permissions.list_initial_departure]}
      >
        <InitialDeparturePilgrims />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/initial-departure-pilgrims/:id/pilgrims",
    Component: (
      <PermissionGate
        permissions={[permissions.view_initial_departure]}
      >
        <ConfirmDepartureList />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/departure_campaigns",
    Component: (
      <PermissionGate
        permissions={[permissions.list_departure_campaigns_index]}
      >
        <CampaignAndGroupDeparture />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/departure_groups",
    Component: (
      <PermissionGate
        permissions={[permissions.list_departure_groups_index]}
      >
        <CampaignAndGroupDeparture />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/flights/create",
    Component: <CreateFlight />,
  },
  {
    path: "makkah/flights/edit/:id",
    Component: <CreateFlight />,
  },
  {
    path: "makkah/flights",
    Component: (
      <PermissionGate
        permissions={[permissions.list_flight_details]}
      >
        <Flights />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/private-transport-contracts",
    Component: (
      <PermissionGate
        permissions={[permissions.list_transport_contracts]}
      >
        <PrivateTransportContracts />
      </PermissionGate>
    ),
  },
  // Reports and Statistics Routes
  {
    path: "makkah/pilgrim-reports",
    Component: <MakkahPilgrimReports />,
  },
  {
    path: "makkah/pilgrim-reports/not-coming",
    Component: (
      <PermissionGate permissions={[permissions.view_pilgrim_report_not_coming_makkah]}>
        <NotComingPilgrimsReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/pilgrim-reports/not-accommodated",
    Component: (
      <PermissionGate permissions={[permissions.view_pilgrim_report_not_accommodated_makkah]}>
        <NotAccommodatedPilgrimsReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/pilgrim-reports/campaign-group-pilgrims",
    Component: (
      <PermissionGate permissions={[permissions.makkah_view_export_campaign_group_pilgrims]}>
        <CampaignGroupPilgrimsReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/pilgrim-reports/pilgrim-nationality-stats",
    Component: (
      <PermissionGate permissions={[permissions.view_pilgrim_report_nationality_stats_makkah]}>
        <PilgrimNationalityStatsReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/pilgrim-reports/pilgrim-mission-stats",
    Component: (
      <PermissionGate permissions={[permissions.view_pilgrim_report_mission_stats_makkah]}>
        <PilgrimMissionStatsReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/pilgrim-reports/accommodated-nationality-stats",
    Component: (
      <PermissionGate permissions={[permissions.view_pilgrim_report_nationality_stats_makkah]}>
        <AccommodatedPilgrimNationalityStatsReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/pilgrim-reports/accommodated-mission-stats",
    Component: (
      <PermissionGate permissions={[permissions.view_pilgrim_report_mission_stats_makkah]}>
        <AccommodatedPilgrimMissionStatsReport />
      </PermissionGate>
    ),
  },
  // تقارير الحملات والمجموعات
  {
    path: "makkah/campaigns-and-groups-reports",
    Component: <CampaignsAndGroupsReports />,
  },
  {
    path: "makkah/campaigns-and-groups-reports/detailed-upcoming-groups-ands-campaigns-report",
    Component: (
      <PermissionGate
        permissions={[
          permissions.view_export_makkah_arrival_campaign_segments_report,
          permissions.view_export_makkah_group_details_report,
        ]}
      >
        <CampaignAndGroupReports />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/campaigns-and-groups-reports/pilgrim-mission-arriving-leaving-statistics-report",
    Component: (
      <PermissionGate
        permissions={[permissions.view_export_makkah_housed_arrivals_service_center_distribution_report]}
      >
        <PilgrimMissionArrivingLeavingStatisticsReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/campaigns-and-groups-reports/campaigns-and-groups-statement-report",
    Component: (
      <PermissionGate
        permissions={[
          permissions.view_export_makkah_campaign_statement_report,
          permissions.view_export_makkah_group_statement_report,
        ]}
      >
        <UpcomingGroupsAndCampaignsDetailsReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/reception-and-arrival-reports",
    Component: <ReceptionAndArrivalReports />,
  },
  {
    path: "makkah/departure-reports",
    Component: <DepartureReports />,
  },
  {
    path: "makkah/housing-reports",
    Component: <HousingReports />,
  },
  {
    path: "makkah/housing-reports/housing-contract-detail",
    Component: (
      <PermissionGate permissions={[permissions.view_export_housing_contract_detail_report]}>
        <HousingContractDetailReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/housing-reports/house-contract-campaigns",
    Component: (
      <PermissionGate permissions={[permissions.view_export_house_contract_campaigns_report]}>
        <HouseContractCampaignsReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/housing-reports/food-contracts",
    Component: (
      <PermissionGate permissions={[permissions.view_export_food_contracts_report]}>
        <FoodContractsReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/housing-reports/housing-comprehensive-detail",
    Component: (
      <PermissionGate permissions={[permissions.view_export_housing_comprehensive_detail_report]}>
        <HousingComprehensiveDetailReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/housing-reports/housing-building-delegate-detail",
    Component: (
      <PermissionGate permissions={[permissions.view_export_housing_building_delegate_detail_report]}>
        <HousingBuildingDelegateDetailReport />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/incident-and-report-logs",
    Component: (
      <PermissionGate permissions={[permissions.makkah_view_export_incident_reports]}>
        <IncidentAndReportLogs />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/compliance-reports",
    Component: (
      <PermissionGate permissions={[permissions.makkah_view_export_incident_reports]}>
        <ComplianceReports />
      </PermissionGate>
    ),
  },
  {
    path: "makkah/users-and-service-centers",
    Component: <UsersAndServiceCenters />,
  },
  // System Management Routes
  {
    path: "makkah/service-centers",
    Component: <ServiceCenters />,
  },
  {
    path: "makkah/system-security",
    Component: <ActivityLogs />,
  },
  // Archives Routes
  {
    path: "makkah/archives",
    Component: <Archives />,
  },
];

const usersManagementRoutes = [
  
  // Users Routes
  {
    path: "user_management/users",
    Component: (
      <PermissionGate permissions={[permissions.list_users_for_user_management]}>
        <Users />
      </PermissionGate>
    ),
  },
  {
    path: "user_management/users/create",
    Component: (
      <PermissionGate permissions={[permissions.create_user_for_user_management]}>
        <CreateUser />
      </PermissionGate>
    ),
  },
  {
    path: "user_management/users/:id/edit",
    Component: (
      <PermissionGate permissions={[permissions.update_user_for_user_management]}>
        <UpdateUser />
      </PermissionGate>
    ),
  },
  {
    path: "user_management/users/:id/reset-password",
    Component: (
      <PermissionGate permissions={[permissions.reset_user_password_for_user_management]}>
        <ResetUserPassword />
      </PermissionGate>
    ),
  },
  {
    path: "user_management/users/:id/profile",
    Component: <DisplayUserProfile />,
  },
  // Groups Routes
  {
    path: "user_management/groups",
    Component: (
      <PermissionGate permissions={[permissions.list_groups_for_user_management]}>
        <Groups />
      </PermissionGate>
    ),
  },
  {
    path: "user_management/groups/create",
    Component: (
      <PermissionGate permissions={[permissions.create_group_for_user_management]}>
        <CreateGroup />
      </PermissionGate>
    ),
  },
  {
    path: "user_management/groups/:id/edit",
    Component: (
      <PermissionGate permissions={[permissions.update_group_for_user_management]}>
        <UpdateGroup />
      </PermissionGate>
    ),
  },
];

const seasonalRecruitmentRoutes = [
  {
    path: "seasonal_hr",
    Component: <SeasonalRecruitment />,
  },
  {
    path: "seasonal_hr/basic-data",
    Component: (
      <PermissionGate permissions={[permissions.basic_data_access]}>
        <BasicData />
      </PermissionGate>
    ),
  },
  {
    path: "seasonal_hr/basic-data/qualifications/create",
    Component: <CreateQualification />,
  },
  {
    path: "seasonal_hr/basic-data/qualifications/:id/edit",
    Component: <EditQualification />,
  },
  {
    path: "seasonal_hr/basic-data/banks/create",
    Component: <CreateBank />,
  },
  {
    path: "seasonal_hr/basic-data/banks/:id/edit",
    Component: <EditBank />,
  },
  {
    path: "seasonal_hr/basic-data/:key",
    Component: <BasicData />,
  },
  {
    path: "seasonal_hr/basic-data/departments/create",
    Component: <CreateDepartment />,
  },
  {
    path: "seasonal_hr/basic-data/departments/:id/edit",
    Component: <EditDepartment />,
  },
  {
    path: "seasonal_hr/basic-data/jobs/create",
    Component: <CreateJob />,
  },
  {
    path: "seasonal_hr/basic-data/jobs/:id/edit",
    Component: <EditJob />,
  },
  {
    path: "seasonal_hr/basic-data/job-sectors/create",
    Component: <JobSectorsForm />,
  },
  {
    path: "seasonal_hr/basic-data/job-sectors/:id/:action",
    Component: <JobSectorsForm />,
  },
];

const madinaRoutes = [

  {
    path: "madina/bags",
    Component: <MadinaBagsRoute />,
  },
  {
    path: "madina/bags/:bag_id/request/:request_number/:mode",
    Component: <MadinaBagsRoute />,
  },
  {
    path: "madina",
    Component: <MadinaDashboard />,
  },
  // Planning and Preparation Routes
  {
    path: "madina/organizers-and-contracts",
    Component: <MadinaOrganizersAndContracts />,
  },
  {
    path: "madina/visas",
    Component: <MadinaVisas />,
  },
  {
    path: "madina/housing",
    Component: <MadinaHousing />,
  },
  // Pilgrims and Groups Routes
  {
    path: "madina/pilgrims",
    Component: <Pilgrims />,
  },
  {
    path: "madina/pilgrims/:id/view",
    Component: <PilgrimDetails />,
  },
  // Nusuk Cards Routes
  {
    path: "madina/nusuk-cards",
    Component: <PermissionGate permissions={[permissions.list_nusuk_cards_batchs_madina]}>
      <NusukCardsNewBatches />
    </PermissionGate>,
  },
  {
    path: "madina/nusuk-cards/returns",
    Component: <PermissionGate permissions={[permissions.list_nusuk_cards_batch_returns_madina]}>
      <NusukCardsBatchReturns />
    </PermissionGate>,
  },
  {
    path: "madina/nusuk-cards/returns/:returnId/view",
    Component: <PermissionGate permissions={[permissions.list_nusuk_cards_batch_returns_madina]}>
      <NusukCardsReturnDetails />
    </PermissionGate>,
  },
  {
    path: "madina/nusuk-cards/returns/:returnId/edit",
    Component: <PermissionGate permissions={[permissions.update_nusuk_cards_batch_returns_madina]}>
      <EditNusukCardsReturn />
    </PermissionGate>,
  },
  {
    path: "madina/nusuk-cards/enter-new-received-new-batches-data",
    Component: <PermissionGate permissions={[permissions.create_nusuk_cards_batchs_madina]}>
      <EnterNewReceivedBatchesData />
    </PermissionGate>,
  },
  {
    path: "madina/nusuk-cards/:id/edit",
    Component: <PermissionGate permissions={[permissions.update_nusuk_cards_batchs_madina]}>
      <EditNusukCardsBatch />
    </PermissionGate>,
  },
  {
    path: "madina/nusuk-cards/:id/view",
    Component: <PermissionGate permissions={[permissions.view_nusuk_cards_batchs_madina]}>
      <NusukCardsBatchDetails />
    </PermissionGate>,
  },
  {
    path: "madina/nusuk-cards-inquiry",
    Component: <PermissionGate permissions={[permissions.list_nusuk_cards_batchs_madina]}>
      <NusukCardsInquiry />
    </PermissionGate>,
  },
  {
    path: "madina/nusuk-cards-reports",
    Component: <PermissionGate permissions={[permissions.view_export_nusuk_cards_batch_report_madina]}>
      <NusukCardsReports />
    </PermissionGate>,
  },

  {
    path: "madina/departure-campaign",
    Component: (
      <PermissionGate mode="any" permissions={[
        permissions.list_departure_campaigns_for_madina,
        permissions.view_departure_campaigns_for_madina,
        permissions.list_departure_campaign_details_for_madina,
        permissions.view_departure_campaign_details_for_madina,
        permissions.create_departure_campaign_details_for_madina,
        permissions.update_departure_campaign_details_for_madina,
        permissions.delete_departure_campaign_details_for_madina,
      ]}>
        <MakkahCampain />
      </PermissionGate>
    ),
  },
  {
    path: "madina/departure-campaign/:id/:port/:mode",
    Component: (
      <PermissionGate
        mode="any"
        permissions={[
          permissions.view_departure_campaigns_for_madina,
          permissions.view_departure_campaign_details_for_madina,
          permissions.view_departure_campaigns_details_for_madina,
          permissions.create_departure_campaign_details_for_madina,
          permissions.update_departure_campaign_details_for_madina,
          permissions.delete_departure_campaign_details_for_madina,
        ]}
      >
        <DepartureCampaign />
      </PermissionGate>
    ),
  },
  {
    path: "madina/center-reception",
    Component: (
      <PermissionGate
        mode="any"
        permissions={[
          permissions.list_madina_reception_manifests,
          permissions.list_madina_reception_manifest_pilgrims,
          permissions.list_madina_reception_tafweejs,
          permissions.list_madina_reception_tafweej_pilgrims,
        ]}
      >
        <CenterReceptionMadina />
      </PermissionGate>
    ),
  },
  {
    path: "madina/arrival-campaign",
    Component: (
      <PermissionGate mode="any" permissions={[
        permissions.list_campaigns_for_madina,
        permissions.view_campaigns_for_madina,
        permissions.create_campaigns_for_madina,
        permissions.update_campaigns_for_madina,
        permissions.delete_campaigns_for_madina,
        permissions.list_campaign_details_for_madina,
        permissions.view_campaign_details_for_madina,
        permissions.create_campaign_details_for_madina,
        permissions.update_campaign_details_for_madina,
        permissions.delete_campaign_details_for_madina,
      ]}>
        <MakkahCampain />
      </PermissionGate>
    ),
  },
  {
    path: "madina/arrival-campaign/:id/:port/:mode",
    Component: (
      <PermissionGate
        mode="any"
        permissions={[
          permissions.view_campaigns_for_madina,
          permissions.view_campaign_details_for_madina,
          permissions.update_campaigns_for_madina,
          permissions.create_campaign_details_for_madina,
          permissions.update_campaign_details_for_madina,
          permissions.delete_campaign_details_for_madina,
        ]}
      >
        <ArrivalCampaignByIdMode />
      </PermissionGate>
    ),
  },
  {
    path: "madina/groups-upcoming",
    Component: (
      <PermissionGate permissions={[permissions.list_groups_for_madina]}>
        <MakkahGroups />
      </PermissionGate>
    ),
  },
  {
    path: "madina/groups-departure",
    Component: (
      <PermissionGate permissions={[permissions.list_groups_for_madina]}>
        <MakkahGroups />
      </PermissionGate>
    ),
  },
  {
    path: "madina/groups-departure/:id/:port/:mode",
    Component: <DepartureGroupDetailMode />,
  },
  {
    path: "madina/groups-upcoming/:mode",
    Component: <GroupMode />,
  },
  {
    path: "madina/groups-upcoming/:id/:mode",
    Component: <GroupMode />,
  },
  {
    path: "madina/compliance",
    Component: <MadinaCompliance />,
  },
  {
    path: "madina/reception",
    Component: (
      <PermissionGate permissions={[permissions.list_port_reception_cards_from_nusk_for_madina]}>
        <ReceptionMadina />
      </PermissionGate>
    ),
  },
  {
    path: "madina/reception/:mode",
    Component: <ReceptionMadinaMode />,
  },
  {
    path: "madina/reception/:id/:mode",
    exact: true,
    Component: <ReceptionMadinaMode />,
  },
  // Bags Routes
  {
    path: "madina/bags",
    Component: <MadinaBagsRoute />,
  },
  {
    path: "madina/bags/:bag_id/request/:request_number/:mode",
    Component: <MadinaBagsRoute />,
  },
  // المســاكـن
  {
    path: "madina/housing-permits",
    Component: 
      <PermissionGate permissions={[permissions.list_housing_for_madina]}>
        <HousingPermits />
      </PermissionGate>,
  },
  {
    path: "madina/housing-permits/:id",
    Component: (
      <PermissionGate permissions={[permissions.view_housing_details_for_madina]}>
        <HousingDetails />
      </PermissionGate>
    ),
  },
  {
    path: "madina/housing-permits/:id/edit",
    Component: 
      <PermissionGate permissions={[permissions.edit_housing_data_for_madina]}>
        <UpdateHousingContract />
      </PermissionGate>,
  },
  // عقــود السكن
  {
    path: "madina/housing-contracts",
    Component: 
    <PermissionGate permissions={[permissions.list_housing_contracts_for_madina]}>
      <HousingContracts />
    </PermissionGate>,
  },
  {
    path: "madina/housing-contracts/:id/view",
    Component: 
    <PermissionGate permissions={[permissions.view_housing_contract_details_for_madina]}>
      <ViewHousingContract />
    </PermissionGate>,
  },
  // فحص جاهزية السكن
  {
    path: "madina/inspection-items",
    Component: 
    // <PermissionGate permissions={[permissions.list_house_inspection_examinations_for_madina]}>
      <HousingInspection />
    // </PermissionGate>,
  },
  {
    path: "madina/housing-inspection",
    Component:  
    <PermissionGate permissions={[permissions.list_house_inspection_examinations_for_madina]}>
      <HousingInspection />
    </PermissionGate>,
  },
  // اوامر فحص السكن
  {
    path: "madina/housing-Inspection-orders",
    Component:   
    <PermissionGate permissions={[permissions.list_house_inspection_orders_for_madina]}>
      <HousingInspectionOrder />
    </PermissionGate>,
  },
  {
    path: "madina/housing-Inspection-orders/:order_number/buildings",
    Component: <HousingInspectionOrderHouses />,
  },
  {
    path: "madina/housing-Inspection-orders/:order_number/buildings/:house_id/housing-inspection-items",
    Component: <HousingInspectionExamination />,
  },
  // ملاحظات فحص السكن
  {
    path: "madina/housing-inspection-notes",
    Component:   
    <PermissionGate permissions={[permissions.list_house_inspection_track_cards_for_madina]}>
      <HousingInspectionNotes />
    </PermissionGate>,
  },
  {
    path: "madina/housing-Inspection-orders/:mode",
    Component: <HousingInspectionOrderFormMode />,
  },
  {
    path: "madina/housing-Inspection-orders/:order_number/:mode",
    Component: <HousingInspectionOrderFormMode />,
  },
  {
    path: "madina/housing-inspection-monitoring",
    Component: <MadinaHousingInspectionMonitoring />,
  },
  {
    path: "madina/follow-up-readiness-reports",
    Component: <MadinaFollowUpReadinessReports />,
  },
  {
    path: "madina/buildings-not-inspected",
    Component: <MadinaBuildingsNotInspected />,
  },
  // Pilgrims and Groups Routes
  {
    path: "madina/pilgrims-and-groups-management",
    Component: <PilgrimsAndGroupsManagement />,
  },
  {
    path: "madina/group-pilgrims-queries",
    Component: <GroupPilgrimsQueries />,
  },
  // Reports and Incidents Routes
  {
    path: "madina/incidents",
    Component: <MadinaIncidents />,
  },
  // Madina MASTER_DATA (basic-data) with tabs like Makkah (cities, service-centers, etc.)
  {
    path: "madina/basic-data",
    Component: <BasicData />,
  },
  {
    path: "madina/basic-data/:key",
    Component: <BasicData />,
  },
  {
    path: "madina/basic-data/examination_periods/:mode",
    Component: <ExaminationPeriodCRUDMode />,
  },
  {
    path: "madina/basic-data/examination_periods/:id/:mode",
    Component: <ExaminationPeriodCRUDMode />,
  },
  {
    path: "madina/basic-data/period_codes/:mode",
    Component: <PeriodCodeCRUDMode />,
  },
  {
    path: "madina/basic-data/period_codes/:id/:mode",
    Component: <PeriodCodeCRUDMode />,
  },
  {
    path: "madina/basic-data/service-centers/create",
    Component: <CreateServiceCenter />,
  },
  {
    path: "madina/basic-data/service-centers/:id/edit",
    Component: <EditServiceCenter />,
  },
  {
    path: "madina/basic-data/groups-upcoming",
    Component: <Navigate to="/app/madina/groups-upcoming" />,
  },
  {
    path: "madina/basic-data/groups-upcoming/:id/:mode",
    Component: <InitialGroupMode />,
  },
  {
    path: "madina/basic-data/campaigns/create",
    Component: <CreateInitialCampaign />,
  },
  {
    path: "madina/basic-data/campaigns/:id/:mode",
    Component: <InitialCampaignMode />,
  },
  {
    path: "madina/basic-data/directions/create",
    Component: <CreateDirection />,
  },
  {
    path: "madina/basic-data/directions/:id/edit",
    Component: <EditDirection />,
  },
  {
    path: "madina/reports",
    Component: (
      <PermissionGate permissions={[permissions.list_madina_incident_reports]}>
        <Reports />
      </PermissionGate>
    ),
  },
  {
    path: "madina/reports/:id/view",
    Component: (
      <PermissionGate permissions={[permissions.view_madina_incident_reports_details]}>
        <ViewReport />
      </PermissionGate>
    ),
  },
  {
    path: "madina/reports/:action",
    Component: (
      <PermissionGate permissions={[permissions.create_madina_incident_reports]}>
        <CreateReport />
      </PermissionGate>
    ),
  },
  {
    path: "madina/reports/:id/:action",
    Component: (
      <PermissionGate permissions={[permissions.update_madina_incident_reports]}>
        <CreateReport />
      </PermissionGate>
    ),
  },
  // Departure Routes
  {
    path: "madina/initial-departure-pilgrims",
    Component: (
      <PermissionGate
        permissions={[
          permissions.list_initial_departure_for_madina
        ]}
      >
        <InitialDeparturePilgrims />
      </PermissionGate>
    ),
  },
  {
    path: "madina/initial-departure-pilgrims/:id/pilgrims",
    Component: (
      <PermissionGate
        permissions={[
          permissions.view_initial_departure_for_madina
        ]}
      >
        <ConfirmDepartureList />
      </PermissionGate>
    ),
  },
  {
    path: "madina/departure_campaigns",
    Component: (
      <PermissionGate
        permissions={[
          permissions.list_departure_campaigns_index_for_madina
        ]}
      >
        <CampaignAndGroupDeparture />
      </PermissionGate>
    ),
  },
  {
    path: "madina/departure_groups",
    Component: (
      <PermissionGate
        permissions={[
          permissions.list_departure_groups_index_for_madina
        ]}
      >
        <CampaignAndGroupDeparture />
      </PermissionGate>
    ),
  },
  {
    path: "madina/flights/create",
    Component: <CreateFlight />,
  },
  {
    path: "madina/flights/edit/:id",
    Component: <CreateFlight />,
  },
  {
    path: "madina/flights",
    Component: (
      <PermissionGate
        permissions={[permissions.list_flight_details_for_madina]}
      >
        <Flights />
      </PermissionGate>
    ),
  },
  {
    path: "madina/private-transport-contracts",
    Component: (
      <PermissionGate
        permissions={[
          permissions.list_transport_contracts_for_madina
        ]}
      >
        <PrivateTransportContracts />
      </PermissionGate>
    ),
  },
  // Reports and Statistics Routes
  {
    path: "madina/pilgrim-reports",
    Component: <MadinaPilgrimReports />,
  },
  {
    path: "madina/pilgrim-reports/not-coming",
    Component: <NotComingPilgrimsReport />,
  },
  {
    path: "madina/pilgrim-reports/not-accommodated",
    Component: <NotAccommodatedPilgrimsReport />,
  },
  {
    path: "madina/pilgrim-reports/campaign-group-pilgrims",
    Component:
    <PermissionGate permissions={[permissions.madina_view_export_campaign_group_pilgrims]}>
      <CampaignGroupPilgrimsReport />
    </PermissionGate>,
  },
  {
    path: "madina/pilgrim-reports/accommodated-nationality-stats",
    Component: <AccommodatedPilgrimNationalityStatsReport />,
  },
  {
    path: "madina/pilgrim-reports/accommodated-mission-stats",
    Component: <AccommodatedPilgrimMissionStatsReport />,
  },
  // تقارير الحملات والمجموعات
  {
    path: "madina/campaigns-and-groups-reports",
    Component: <MadinaCampaignAndGroupReports />,
  },
  {
    path: "madina/campaigns-and-groups-reports/detailed-upcoming-groups-ands-campaigns-report",
    Component: (
      <PermissionGate
        permissions={[
          permissions.view_export_madina_arrival_campaign_segments_report,
          permissions.view_export_madina_group_details_report,
        ]}
        mode="any"
      >
        <CampaignAndGroupReports />
      </PermissionGate>
    ),
  },
  {
    path: "madina/campaigns-and-groups-reports/pilgrim-mission-arriving-leaving-statistics-report",
    Component: (
      <PermissionGate
        permissions={[permissions.view_export_madina_housed_arrivals_service_center_distribution_report]}
      >
        <PilgrimMissionArrivingLeavingStatisticsReport />
      </PermissionGate>
    ),
  },
  {
    path: "madina/campaigns-and-groups-reports/campaigns-and-groups-statement-report",
    Component: (
      <PermissionGate
        permissions={[
          permissions.view_export_madina_campaign_statement_report,
          permissions.view_export_madina_group_statement_report,
        ]}
        mode="any"
      >
        <UpcomingGroupsAndCampaignsDetailsReport />
      </PermissionGate>
    ),
  },
  {
    path: "madina/reception-and-arrival-reports",
    Component: <MadinaReceptionAndArrivalReports />,
  },
  {
    path: "madina/departure-reports",
    Component: <MadinaDepartureReports />,
  },
  {
    path: "madina/housing-reports",
    Component: <MadinaHousingReports />,
  },
  {
    path: "madina/housing-reports/housing-contract-detail",
    Component: (
      <PermissionGate permissions={[permissions.view_export_housing_contract_detail_report_for_madina]}>
        <MadinahHousingContractDetailReport />
      </PermissionGate>
    ),
  },
  {
    path: "madina/housing-reports/house-contract-campaigns",
    Component: (
      <PermissionGate
        permissions={[permissions.view_export_house_contract_campaigns_report_for_madina]}
      >
        <MadinahHouseContractCampaignsReport />
      </PermissionGate>
    ),
  },
  {
    path: "madina/housing-reports/food-contracts",
    Component: (
      <PermissionGate permissions={[permissions.view_export_food_contracts_report_for_madina]}>
        <MadinahFoodContractsReport />
      </PermissionGate>
    ),
  },
  {
    path: "madina/housing-reports/housing-comprehensive-detail",
    Component: (
      <PermissionGate
        permissions={[permissions.view_export_housing_comprehensive_detail_report_for_madina]}
      >
        <MadinahHousingComprehensiveDetailReport />
      </PermissionGate>
    ),
  },
  {
    path: "madina/housing-reports/housing-building-delegate-detail",
    Component: (
      <PermissionGate
        permissions={[permissions.view_export_housing_building_delegate_detail_report_for_madina]}
      >
        <MadinahHousingBuildingDelegateDetailReport />
      </PermissionGate>
    ),
  },
  {
    path: "madina/incident-and-report-logs",
    Component: (
      // <PermissionGate permissions={[permissions.view_export_madina_incident_reports_report]}>
      //   <MadinaIncidentAndReportLogs />
      // </PermissionGate>
      <PermissionGate permissions={[permissions.madina_view_export_incident_reports]}>
        <IncidentAndReportLogs />
      </PermissionGate>
    ),
  },
  {
    path: "madina/compliance-reports",
    Component: <MadinaComplianceReports />,
  },
  {
    path: "madina/users-and-service-centers",
    Component: <MadinaUsersAndServiceCenters />,
  },
  // System Management Routes
  {
    path: "madina/system-security",
    Component: <ActivityLogs />,
  },
];

export const routes = {
  makkah: makkahRoutes,
  user_management: usersManagementRoutes,
  seasonal_hr: seasonalRecruitmentRoutes,
  madina: madinaRoutes,
};
